"use strict";
// type OnShowCallback = (
//   content: ToastContent,
//   options: NotValidatedToastProps
// ) => void;
// type OnClearCallback = (id?: Id) => void;
// type OnClearWaitingQueue = (params: ClearWaitingQueueParams) => void;
// type OnDidMountCallback = (containerInstance: ContainerInstance) => void;
// type OnWillUnmountCallback = OnDidMountCallback;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    manager: new Map(),
    on(event, callback) {
        this.manager.has(event) || this.manager.set(event, []);
        this.manager.get(event).push(callback);
        return this;
    },
    off(event) {
        this.manager.delete(event);
        return this;
    },
    emit(event, ...args) {
        if (!this.manager.has(event)) {
            return false;
        }
        this.manager
            .get(event)
            .forEach((callback) => setTimeout(() => callback.call(null, ...args), 0));
        return true;
    },
};
